var Accordeon = {
    init:function(){
        console.log("Accordeon init");
        $(".block-accordeon .accordeon-title").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            console.log("CLICK ACCORDEON : " + $(this).parent().hasClass("open"));
            if($(this).closest(".block-accordeon").hasClass("open")){
                Accordeon.close_accordeon($(this).closest(".block-accordeon"));
            }else{
                Accordeon.open_accordeon($(this).closest(".block-accordeon"));
            }
        });

        $(".block-accordeon .btn-close").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            Accordeon.close_accordeon($(this).closest(".block-accordeon"));

        });
    },
    open_accordeon:function(pTarget){
        pTarget.addClass("open");
        pTarget.find(".accordeon-container").css({height:pTarget.find(".accordeon-content").outerHeight()});
    },
    close_accordeon:function(pTarget){
        pTarget.removeClass("open");
        pTarget.find(".accordeon-container").css({height:0});
    }
}

$(window).on("load", function(){

    if($(".akrolab-template .block-accordeon").length){
        Accordeon.init();
    }
});